<template>
    <Breadcrumbs main="Form Controls" title="Input Groups" />
    <div class="container-fluid">
        <div class="row">
            <buttonAddons />
            <customForms />
            <fileInput />
            <buttonsDropdowns />
            <segmentedButtons />
            <checkboxesRadios />
            <sizingInput />
            <multipleInputs />
            <basicInput />
            <variationAddons />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const buttonAddons = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/buttonAddons.vue"))
const customForms = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/customForms.vue"))
const fileInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/fileInput.vue"))
const buttonsDropdowns = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/buttonsDropdowns.vue"))
const segmentedButtons = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/segmentedButtons.vue"))
const checkboxesRadios = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/checkboxesRadios.vue"))
const sizingInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/sizingInput.vue"))
const multipleInputs = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/multipleInputs.vue"))
const basicInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/basicInput.vue"))
const variationAddons = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/variationAddons.vue"))
</script>